module.exports = __webpack_public_path__ + "media/scholarship_winners/brittany-b-e48b063a.png";